/* RESPONSIBLE TEAM: team-frontend-tech */

function isJavascriptOrDataUri(uri: string): boolean {
  return /^\s*javascript:/i.test(uri) || /^\s*data:/i.test(uri);
}

// @ts-expect-error Unused arguments
export default function (url: string, name?: string, options?: string) {
  if (isJavascriptOrDataUri(url)) {
    console.error('Cannot open new window, URL is to a disallowed protocol.');
    return;
  }
  return window.open(...arguments); //eslint-disable-line @intercom/intercom/no-window-open
}
